




















































































































































































import Vue from 'vue'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiSkeleton from '@/components/UiSkeleton.vue'
import UiIcon from '@/components/UiIcon.vue'
import UiChip from '@/components/UiChip.vue'
import {AVAILABLE_ROLES} from '@/constants'
import { InvitationInterface, OrganizationBrandInterface, OrganizationUserInterface, UploadInterface } from '@/types/interfaces'
import { dataUrlAdapter, fileAdapter, imgAdapter } from '@/services/fileAdapter'
import { storage } from '@/services/firebaseAdapter'

const initInviteDraft = () => {
  return {
    name: "",
    email: "", 
    role: "reader"
  }
}

export default Vue.extend({
  name: "Admin",
  data(){
    return {
      loadedUsers: false,
      loadedInvitations: false,
      isSubmittingInvite: false,
      loadingMoreUsers: false,
      loadingMoreInvitations: false,
      isSubmittingOrg: false,
      activeTab: 0,
      inviteDraft: initInviteDraft(),
      orgDraft: {} as OrganizationBrandInterface,
      orgLogoDraft: null as null | File
    }
  },
  computed: {
    organization(){ return this.$store.getters.organization },
    availableRoles(){
      return AVAILABLE_ROLES.map(role => {
        return {
          value: role,
          name: this.$t(`constants.availableRoles.${role}`)
        }
      })
    },
    users(){ return this.$store.getters.privateUsers },
    areAllUsersLoaded(){ return this.$store.getters.loadedAllPrivateUsers },
    invitations(){ return this.$store.getters.privateInvitations },
    areAllInvitationsLoaded(){ return this.$store.getters.loadedAllPrivateInvitations },
  },
  methods: {
    handleTabClick(tabIndex: number){
      this.activeTab = tabIndex
    },
    isOnlyOneAdmin(){ return this.users.filter((user: OrganizationUserInterface) => user.role == "admin").length == 1 },
    emailExistsAsUserOrInvite(email: string){
      return this.users.some((user: OrganizationUserInterface) => user.email == email) ||
        this.invitations.some((invite: InvitationInterface) => invite.email == email)
    },
    async handleInviteSubmit(){
      if(!this.inviteDraft.email || !this.inviteDraft.name) return alert(this.$t('error.submissionIncomplete'))
      if(this.emailExistsAsUserOrInvite(this.inviteDraft.email)) return alert(this.$t('error.submissionEmailExists'))

      try {
        this.isSubmittingInvite = true
        // Create invitation in database
        await this.$store.dispatch('createInvitation', this.inviteDraft)
        // Reload invitations
        await this.$store.dispatch('loadOrganizationInvitations')
        // Reset Invite form
        this.inviteDraft = initInviteDraft()
      } catch (error) {
        alert(this.$t('error.submitFailed'))
      }
      this.isSubmittingInvite = false
    },
    async handleInviteRoleChange(event: any, invitation: InvitationInterface){
      await this.$store.dispatch('updateInvitationRole', {
        invitationId: invitation.id,
        role: event.target.value
      })
    },
    async handleInviteDelete(invitationId: string){
      if(!confirm( this.$t('confirmDeleteInvitation').toString() )) return
      await this.$store.dispatch('deleteInvitation', invitationId)
    },
    async handleUserRoleChange(event: any, user: OrganizationUserInterface){
      const newUser = Object.assign({}, user)
      newUser.role = event.target.value
      await this.$store.dispatch('updateUser', newUser)
    },
    async handleUserDelete(userId: string){
      if(!confirm( this.$t('confirmDeleteUser').toString() )) return
      await this.$store.dispatch('deleteUser', userId)
    },
    inviteUrl(code: string){
      return `${window.location.host}/${this.organization.id}/signup/${code}`
    },
    // LOAD MORE: 
    async handleLoadMoreUsers(){
      this.$data.loadingMoreUsers = true
      // Load next page
      await this.$store.dispatch('loadOrganizationUsers', {
        isLoadMore: true,
      })
      this.$data.loadingMoreUsers = false
    },
    async handleLoadMoreInvitations(){
      this.$data.loadingMoreInvitations = true
      // Load next page
      await this.$store.dispatch('loadOrganizationInvitations', {
        isLoadMore: true,
      })
      this.$data.loadingMoreInvitations = false
    },
    setCurrentOrganizationDraft(){
      this.orgDraft = Object.assign({}, this.organization.brand)
    },
    async handleLogoInputChange(e: any){
      try {
        const files = e.target.files || e.dataTransfer.files
        const file = files[0]
        // Check presence of image file:
        if (
          !files.length || 
          !fileAdapter.isImage(file)
        ) throw("ERROR in handleLogoInputChange: No image files found")
        // Resize Image:
        const resizedImg = await imgAdapter.limitSize(file, {height: 460, width: 460})
        const imgAsDataUrl = await fileAdapter.asDataUrl(resizedImg)
        // Set new image as data URL of draft:
        this.orgDraft.logo = imgAsDataUrl
        // Set file draft for upload on save:
        this.orgLogoDraft = resizedImg
      } catch (error) {
        console.error(error)
        alert(this.$t('orgEdit.errorSelectFile'))
      }
    },
    async handleOrgEditSubmit(){
      try {
        this.isSubmittingOrg = true
        // Verify presence of all fields:
        if(
          !this.orgDraft.name ||
          !this.orgDraft.color ||
          !this.orgDraft.logo
        ) throw("ERROR in handleOrgEditSubmit: Not all fields are present")

        // Optionally Upload image
        if(this.orgLogoDraft){
          const fileExtension = fileAdapter.getExtension(this.orgLogoDraft)
          const uploadResponse : UploadInterface = await this.$store.dispatch('uploadOrganizationLogo', {
            file: this.orgLogoDraft,
            path: `${this.organization.static.shortId}/organization/logo.${fileExtension}`
          })
          this.orgDraft.logo = uploadResponse.publicURL
        }

        // POST Update:
        await this.$store.dispatch('updateOrganizationBrand', this.orgDraft)
        // Update draft in case the server version was different from the local one:
        this.setCurrentOrganizationDraft()
        this.orgLogoDraft = null
      } catch (error) {
        console.error(error)
        alert(this.$t('orgEdit.submitError'))
      } finally {
        this.isSubmittingOrg = false
      }
    },
  },
  async mounted(){
    // GET users from database
    await this.$store.dispatch('loadOrganizationUsers')
    this.$data.loadedUsers = true
    // GET invitations from database
    await this.$store.dispatch('loadOrganizationInvitations')
    this.$data.loadedInvitations = true
    // Set current organization brand details as draft:
    this.setCurrentOrganizationDraft()
  },
  async beforeRouteUpdate(){ // Reload when route changes without mount
    // GET users from database
    await this.$store.dispatch('loadOrganizationUsers')
    this.$data.loadedUsers = true
    // GET invitations from database
    await this.$store.dispatch('loadOrganizationInvitations')
    this.$data.loadedInvitations = true
  },
  components: {
    AppHeader,
    AppFooter,
    UiCard,
    UiButton,
    UiSkeleton,
    UiIcon,
    UiChip,
  }
})
